export interface I_UA_INFO {
  titansx?: string
  titansnox?: string
  meituangroup?: string
  dp?: string
  phoenix?: string
  version?: string
  ios?: string
  android?: string
  micromessenger?: string
  [x: string]: any
}

export interface I_BASE_AGENT {
  uaInfo: I_UA_INFO
  osVersion: string
  ltios11: boolean
  iphone: boolean
  iphonex: boolean
  ipad: boolean
  android: boolean
  weibo: boolean
  // Mozilla/5.0 (iPhone; CPU iPhone OS 12_1_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/12.0 MQQBrowser/9.1.0 Mobile/16D57 Safari/604.1 MttCustomUA/2 QBWebViewType/1 WKType/1
  qq: boolean
  qzone: boolean
  // Mozilla/5.0 (iPhone; CPU iPhone OS 12_1_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/16D57 MicroMessenger/7.0.3(0x17000321) NetType/WIFI Language/zh_CN
  weixin: boolean
  // Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_3) AppleWebKit/605.1.15 (KHTML, like Gecko) MicroMessenger/2.3.23(0x12031710) MacWechat NetType/WIFI pcwechat
  pcwechat: boolean
  native: boolean // 公司内部APP
  harmonyNative: boolean // 鸿蒙app
  android_Ios_HarmonyNative: boolean // 鸿蒙&安卓&苹果app
  pc: boolean
  wxwork: boolean // 企业微信
  wkwebview: boolean
  // Mozilla/5.0 (iPhone; CPU iPhone OS 13_1_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 swan/2.9.0 swan-baiduboxapp/11.12.0.18 baiduboxapp/11.12.0.18 (Baidu; P2 13.1.3)
  // Mozilla/5.0 (Linux; Android 9; Pixel 2 XL Build/PQ2A.190405.003; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/71.0.3578.99 Mobile Safari/537.36 swan/2.1.0 swan-xhsdiscover/5.49.0 (Baidu; P1 9)
  swan: boolean
  wide: boolean
  miniprogram: boolean
  anyminiprogram: boolean
  msc: boolean
  harmony: boolean
}

export enum NATIVE_APP_NAME {
  phoenix_i = 'phoenix_i',
  phoenix = 'phoenix',
  group = 'group',
  dianping_nova = 'dianping_nova',
}

export enum QUERY_PARAM_KEY {
  mina_name = 'mina_name',
  programName = 'programName',
  referMiniProgram = 'referMiniProgram',
}

export type I_WXAPP_NAME_MAP = Partial<{
  'meituan-wxapp': string
  'dianping-wxapp': string
  'hotel-wxapp': string
  'zhenguo-wxapp': string
  'zhenguo-swan': string
  mt: string
  dp: string
  hotel: string
  weChat_mt: string
  weChat_dp: string
  weChat: string
  'mt-weapp': string
  [x: string]: any
}>

export enum WXAPP_NAME {
  group_wxapp = 'group_wxapp',
  dianping_wxapp = 'dianping_wxapp',
  hotel_wxapp = 'hotel_wxapp',
  ticket_wxapp = 'ticket_wxapp',
  phoenix_wxapp = 'phoenix_wxapp',
  phoenix_bdapp = 'phoenix_bdapp',
  phoenix_xhsapp = 'phoenix_xhsapp',
}

export enum WEBVIEW_TYPE {
  phxMpWebview = 'phxMpWebview',
  groupMpWebview = 'groupMpWebview',
  dianpingMpWebview = 'dianpingMpWebview',
  hotelMpWebview = 'hotelMpWebview',
  ticketMpWebview = 'ticketMpWebview',
}

export interface I_WEBVIEW {
  appnm: WXAPP_NAME
  type: WEBVIEW_TYPE
}

export const APP_NAME = { ...NATIVE_APP_NAME, ...WXAPP_NAME }
// eslint-disable-next-line @typescript-eslint/no-redeclare -- intentionally naming the variable the same as the type
export type APP_NAME = keyof typeof APP_NAME

export interface I_APP_AGENT {
  appnm: APP_NAME
  version?: string
  phx?: boolean
  meituan?: boolean
  dianping?: boolean
  group_wxapp?: boolean
  phoenix_wxapp?: boolean
  dianping_wxapp?: boolean
  groupMpWebview?: boolean
  [x: string]: any
}

export type I_MP_AGENT =
  | {
      appnm: APP_NAME
      version: string
      [x: string]: any
    }
  | undefined

export type I_AGENT = I_BASE_AGENT & I_APP_AGENT & I_MP_AGENT
